export default "__VITE_ASSET__BFaE2YLT__"